export default {
  data () {
    return {
      rules: {
        required: value => !!value || 'Required.',
        number: value => !isNaN(value) || 'Must be a number.'
      }
    }
  }
}
